var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "related-clinic-item rounded-20 pa-4",
      class: {
        "bg-gray-40": _vm.isStriped,
        "related-clinic-item--mobile flex-column ga-4": _setup.isMobile,
        "d-flex align-center ga-5": !_setup.isMobile,
      },
      attrs: { "data-qa": "lpu_related_clinics_item" },
    },
    [
      _c("div", { staticClass: "flex-grow-1 min-w-0 d-flex flex-column" }, [
        _c(
          "a",
          {
            staticClass:
              "related-clinic-item__name text-subtitle-1 font-weight-medium primary--text text-decoration-none",
            attrs: {
              "data-qa": "lpu_related_clinics_name",
              href: _vm.clinic.url,
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.clinic.name) + "\n    ")]
        ),
        _vm._v(" "),
        _vm.clinic.address
          ? _c("div", { staticClass: "d-flex align-center ga-2 mt-2" }, [
              _c("span", {
                staticClass:
                  "ui-icon-ui-location ui-icon-fz-smaller bg-gray-80--text flex-shrink-0",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-body-2 text-secondary--text" }, [
                _vm._v("\n        " + _vm._s(_vm.clinic.address) + "\n      "),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _setup.phoneFormatted
        ? _c(
            "div",
            {
              staticClass:
                "related-clinic-item__phone d-flex align-center ga-2 flex-shrink-0",
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text text-decoration-none",
                  class: _setup.isMobile ? "mt-2" : "",
                  attrs: {
                    "data-qa": "lpu_related_clinics_phone",
                    href: `tel:${_setup.phoneHref}`,
                  },
                },
                [
                  !_setup.isMobile
                    ? _c("span", {
                        staticClass:
                          "ui-icon-phone-call ui-icon-fz-big bg-gray-80--text flex-shrink-0",
                        attrs: { "aria-hidden": "true" },
                      })
                    : _vm._e(),
                  _vm._v("\n      " + _vm._s(_setup.phoneFormatted) + "\n    "),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }